import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    ExternalReceptacleLinkColumn,
    TextColumn,
    DateColumn,
    DurationColumn,
    NonZeroFloatColumn,
    NonZeroNumberColumn,
  } = columns(data);
  return [
    {
      Header: 'PREDES',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'predes.receptacleId').withWidth(300)),
        new TextColumn('Origin IMPC', 'predes.originImpc'),
        new TextColumn('Destination IMPC', 'predes.destinationImpc'),
        new TextColumn('Mail category', 'predes.mailCategory'),
        new TextColumn('Mail subclass', 'predes.mailSubclass'),
        new TextColumn('Receptacle type', 'predes.receptacleType'),
        new TextColumn('Handling class', 'predes.handlingClass'),
        new TextColumn('Tracked', 'predes.tracked'),
        new NonZeroNumberColumn('Items', 'predes.items'),
      ],
    },
    {
      Header: 'Despatch close',
      columns: [
        new DateColumn('Date', 'despatchClose.date'),
        new TextColumn('Day', 'despatchClose.day'),
        new DurationColumn('Time', 'despatchClose.time'),
      ],
    },
    {
      Header: 'Weight',
      columns: [
        new NonZeroFloatColumn('Preadvised', 'weight.preadvised'),
        new NonZeroFloatColumn('Responded', 'weight.responded'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateColumn('Event date', 'resdes.eventDate'),
        new DurationColumn('Event time', 'resdes.eventTime'),
        new NonZeroNumberColumn('Event code', 'resdes.eventCode'),
        new TextColumn('Event description', 'resdes.eventDescription'),
      ],
    },
  ];
};
